import { AlertTriangle } from "lucide-react";
import CleButton from "@cle/components/CleButton";
import { formatLessons } from "@cle/utils/lessonLimits";

type ReportSubmitWarningStepProps = {
  missingLessons: number;
  requiredLessons: number;
  selectedLessons: number;
  onCancel: () => void;
  onConfirm: () => void;
};

const ReportSubmitWarningStep = ({
  missingLessons,
  onCancel,
  onConfirm,
  requiredLessons,
  selectedLessons,
}: ReportSubmitWarningStepProps) => {
  return (
    <div>
      <div className="d-flex align-items-start gap-3 mb-4">
        <span
          className="rounded-circle bg-warning-subtle text-warning-emphasis d-inline-flex align-items-center justify-content-center flex-shrink-0"
          style={{ width: "3rem", height: "3rem" }}
          aria-hidden="true"
        >
          <AlertTriangle size={24} strokeWidth={2} />
        </span>
        <div>
          <h2 className="display-4 fw-semibold mb-2">Du mangler lektioner</h2>
          <p className="mb-0">
            Du har valgt <strong>{formatLessons(selectedLessons)}</strong> af{" "}
            <strong>{formatLessons(requiredLessons)}</strong> krævede lektioner.
            Det betyder, at der mangler{" "}
            <strong>{formatLessons(missingLessons)}</strong> lektioner i
            indberetningen.
          </p>
        </div>
      </div>

      <div className="alert alert-warning" role="alert">
        Du kan fortsætte, men du skal bekræfte, at du er opmærksom på, at
        lektionskravet ikke er opfyldt.
      </div>

      <div className="d-flex justify-content-between gap-3">
        <CleButton
          id="cle-cancel-report-warning"
          variant="outline"
          onClick={onCancel}
        >
          Annuller
        </CleButton>
        <CleButton id="cle-accept-report-warning" onClick={onConfirm}>
          Okay, fortsæt
        </CleButton>
      </div>
    </div>
  );
};

export default ReportSubmitWarningStep;
